module.exports = __webpack_public_path__ + "static/media/xiaoya-qywx.2b130d48.png";